import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { IsMobile } from "utils/is-mobile";
import ProductGalleryModal from "./product-gallery-modal";

const PRODUTO_SEM_IMAGEM_URL =
  "https://karsten-swagger-api-docs.s3.amazonaws.com/ProdutoSemImagem.png";

const useStyles = makeStyles(() => ({
  imageCarousel: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
    msOverflowStyle: "none",
    scrollbarWidth: "none",
  },
  scrollHidden: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
    msOverflowStyle: "none",
    scrollbarWidth: "none",
  },
  numberInput: {
    "&::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    "&::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    MozAppearance: "textfield",
  },
}));

export default function ProductCard({
  product,
  brandColors,
  selectedBrand,
  quantity,
  onQuantityChange,
  onAddToCart,
  onShowSpecs,
  onCarouselScroll,
}) {
  const classes = useStyles();
  const mobile = IsMobile();
  const [galleryModalOpen, setGalleryModalOpen] = useState(false);
  const [galleryModalIndex, setGalleryModalIndex] = useState(0);

  const fotosRaw = (product.fotos || []).filter(Boolean);
  const fotos =
    fotosRaw.length > 0 ? fotosRaw : [PRODUTO_SEM_IMAGEM_URL];
  const hasMultipleFotos = fotosRaw.length > 1;

  const isKarstenProduct = product.marcaId === 1 || product.marcaId === 3;
  const isMixLayout = selectedBrand === "mix";
  const isTrussardiLayout = selectedBrand === "trussardi";

  const priceColor = isMixLayout
    ? isKarstenProduct
      ? brandColors.karstenAccent
      : brandColors.trussardiAccent
    : brandColors.primary;

  let discountBadgeHTML = null;
  if (product.desconto) {
    const badgeColor = isMixLayout
      ? isKarstenProduct
        ? brandColors.karstenAccent
        : brandColors.trussardiAccent
      : brandColors.primary;
    discountBadgeHTML = (
      <div
        style={{
          position: "absolute",
          top: "8px",
          left: "8px",
          fontSize: "12px",
          fontWeight: "bold",
          padding: "4px 8px",
          borderRadius: "6px",
          backgroundColor: badgeColor,
          color: "white",
          zIndex: 10,
        }}
      >
        -{product.desconto}%
      </div>
    );
  }

  const brandIndicator = isMixLayout ? (
    <div
      style={{
        position: "absolute",
        top: "8px",
        right: "8px",
        fontSize: "12px",
        fontWeight: "bold",
        padding: "4px 8px",
        borderRadius: "9999px",
        backgroundColor: isKarstenProduct
          ? brandColors.karstenAccent
          : brandColors.trussardiAccent,
        color: "white",
      }}
    >
      {isKarstenProduct ? "K" : "T"}
    </div>
  ) : null;

  return (
    <div
      data-product-id={product.idProduto}
      className={isTrussardiLayout || isMixLayout ? "surface" : ""}
      style={{
        backgroundColor: brandColors.surface,
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        transition: "all 0.3s",
        position: "relative",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          aspectRatio: "4/3",
        }}
        onMouseEnter={(e) => {
          const buttons = e.currentTarget.querySelectorAll(
            "[data-carousel-button]"
          );
          buttons.forEach((btn) => {
            btn.style.opacity = "1";
          });
        }}
        onMouseLeave={(e) => {
          const buttons = e.currentTarget.querySelectorAll(
            "[data-carousel-button]"
          );
          buttons.forEach((btn) => {
            btn.style.opacity = "0";
          });
        }}
      >
        {discountBadgeHTML}
        {brandIndicator}
        <div
          className={`${classes.imageCarousel} ${classes.scrollHidden}`}
          data-carousel="true"
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            overflowX: "scroll",
            scrollSnapType: "x mandatory",
            scrollBehavior: "smooth",
            WebkitOverflowScrolling: "touch",
            msOverflowStyle: "none",
            scrollbarWidth: "none",
            cursor: "pointer",
          }}
        >
          {fotos.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={product.name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                scrollSnapAlign: "start",
                flexShrink: 0,
              }}
              onClick={() => {
                setGalleryModalIndex(idx);
                setGalleryModalOpen(true);
              }}
              onError={(e) => {
                e.target.src =
                  "https://placehold.co/600x600/ccc/fff?text=Error";
              }}
            />
          ))}
        </div>
        {hasMultipleFotos && (
          <>
            <button
              data-carousel-button="prev"
              onClick={() => onCarouselScroll(product.idProduto, "prev")}
              style={{
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
                backgroundColor: brandColors.primary,
                color: "white",
                borderRadius: "9999px",
                padding: "8px",
                border: "none",
                cursor: "pointer",
                opacity: 0,
                transition: "opacity 0.3s",
                zIndex: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "auto",
              }}
            >
              <ChevronLeftIcon style={{ fontSize: "20px" }} />
            </button>
            <button
              data-carousel-button="next"
              onClick={() => onCarouselScroll(product.idProduto, "next")}
              style={{
                position: "absolute",
                top: "50%",
                right: "8px",
                transform: "translateY(-50%)",
                backgroundColor: brandColors.primary,
                color: "white",
                borderRadius: "9999px",
                padding: "8px",
                border: "none",
                cursor: "pointer",
                opacity: 0,
                transition: "opacity 0.3s",
                zIndex: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "auto",
              }}
            >
              <ChevronRightIcon style={{ fontSize: "20px" }} />
            </button>
          </>
        )}
      </div>

      <ProductGalleryModal
        open={galleryModalOpen}
        onClose={() => setGalleryModalOpen(false)}
        productName={product.name}
        fotos={fotos}
        initialIndex={galleryModalIndex}
        brandColors={brandColors}
      />

      <div
        style={{
          padding: mobile ? "12px" : "16px",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h3
          style={{
            fontSize: mobile ? "14px" : "16px",
            marginBottom: "8px",
            fontWeight: "bold",
            color: brandColors.textBase,
            fontFamily: "inherit",
            flexGrow: 1,
          }}
        >
          {product.name}
        </h3>
        <span
          style={{
            fontSize: "12px",
            color: brandColors.textMuted,
            marginBottom: "16px",
          }}
        >
          Cód: {product.codigo}
        </span>
        <button
          onClick={() => onShowSpecs(product)}
          style={{
            fontSize: "14px",
            fontWeight: 600,
            color: priceColor,
            background: "none",
            border: "none",
            cursor: "pointer",
            textDecoration: "underline",
            marginBottom: "16px",
            padding: 0,
            textAlign: "left",
          }}
        >
          Especificações
        </button>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: `1px solid ${brandColors.border}`,
              borderRadius: "8px",
            }}
          >
            <button
              onClick={() => onQuantityChange(product.idProduto, -1)}
              style={{
                padding: "8px",
                border: "none",
                background: "transparent",
                cursor: "pointer",
                color: brandColors.textBase,
              }}
            >
              -
            </button>
            <input
              type="number"
              value={quantity}
              readOnly
              min="1"
              className={classes.numberInput}
              style={{
                width: mobile ? "40px" : "48px",
                textAlign: "center",
                borderLeft: `1px solid ${brandColors.border}`,
                borderRight: `1px solid ${brandColors.border}`,
                borderTop: "none",
                borderBottom: "none",
                outline: "none",
                backgroundColor: "transparent",
                padding: "8px 4px",
              }}
            />
            <button
              onClick={() => onQuantityChange(product.idProduto, 1)}
              style={{
                padding: "8px",
                border: "none",
                background: "transparent",
                cursor: "pointer",
                color: brandColors.textBase,
              }}
            >
              +
            </button>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: mobile ? "flex-start" : "flex-end",
            }}
          >
            {product.precoAnterior ? (
              <>
                <span
                  style={{
                    fontSize: "12px",
                    color: brandColors.textMuted,
                    textDecoration: "line-through",
                  }}
                >
                  De R$ {product.precoAnterior}
                </span>
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: priceColor,
                  }}
                >
                  Por R$ {product.preco}
                </span>
              </>
            ) : (
              <span
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: priceColor,
                }}
              >
                R$ {product.preco}
              </span>
            )}
          </div>
        </div>
        <button
          onClick={() => {
            if (quantity > 0) {
              onAddToCart(product.idProduto, quantity);
            } else {
              const btn = document.querySelector(
                `[data-product-id="${product.idProduto}"] button:last-child`
              );
              if (btn) {
                const originalBg = btn.style.backgroundColor;
                const originalText = btn.textContent;
                btn.style.backgroundColor = "red";
                btn.textContent = "Informe a Qtd!";
                setTimeout(() => {
                  btn.style.backgroundColor = originalBg;
                  btn.textContent = originalText;
                }, 2000);
              }
            }
          }}
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: brandColors.primary,
            color: "white",
            fontWeight: "bold",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            transition: "background-color 0.3s",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = brandColors.primaryHover;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = brandColors.primary;
          }}
        >
          Adicionar ao carrinho
        </button>
      </div>
    </div>
  );
}
